/**
 * Parses the file and returns the schema object
 * @param {string} schemaContent
 * @returns {object}
 */
function parseSchemaFile(schemaContent){

  if (!schemaContent)
    throw new Error(`Expected a string but passed in ${schemaContent} for
      'schemaContent' variable.`.replace(/\s+/g, ' '))

  if (isES6Module(schemaContent))
    return {
      schema: parseES6SchemaFile(schemaContent),
      type: 'ES6_MODULE',
    }

  if (isCommonJSModule(schemaContent))
    return {
      schema: parseCommonJSSchemaFile(schemaContent),
      type: 'COMMON_JS',
    }

  return {
    schema: parseSchemaJSON(schemaContent),
    type: 'JSON',
  }

}

export default parseSchemaFile

/**
 * Returns whether or not the file is an ES6 module
 * @param {string} content
 * @returns {boolean}
 */
function isES6Module(content){
  return /^\s*export\s+default/.test(content)
}

/**
 * Returns whether or not the file is an ES6 module
 * @param {string} content
 * @returns {boolean}
 */
function isCommonJSModule(content){
  return /^\s*module.exports\s+=/.test(content)
}

/**
 * Parses a file that's an ES6 module. It's a naive implementation and only
 * checks for `export default` at the start
 * @param {*} content
 * @returns {string}
 */
function parseES6SchemaFile(content){
  content = content.replace(/^\s*export\s+default/, '').trim()
  return parseSchemaJSON(content)
}

/**
 * Parses a file that's an common JS module. It's a naive implementation and only
 * checks for `modules.exports =` at the start
 * @param {*} content
 * @returns {string}
 */
function parseCommonJSSchemaFile(content){
  content = content.replace(/^\s*module.exports\s+=/, '').trim()
  return parseSchemaJSON(content)
}

/**
 * Parse the schema string JSON into an object.
 * @param {string} content
 * @returns {object}
 */
function parseSchemaJSON(content){
  if (!content)
    throw new Error(`Expected a string but passed in ${content} for 'content' variable.`)
  try {
    var schema = JSON.parse(content)
  } catch (err){
    err.message = `The schema is not valid JSON, unable to parse it`
    err.code = 'INVALID_JSON_IN_SCHEMA'
    throw err
  }
  return schema
}



// WEBPACK FOOTER //
// ./src/modules/BranchEditor/Container/parseSchemaFile.js